module.exports = "<p>\n  highcharts-chart works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/highcharts-chart/highcharts-chart.component.html
// module id = ../../../../../src/app/components/highcharts-chart/highcharts-chart.component.html
// module chunks = main